import { trackQuintoEvent } from 'dashboard/helper/lais/trackingEvents';
import { visitTrackingPayload } from './visitDetailPresenter';

export const VISIT_TRACKING_EVENTS = Object.freeze({
  DETAIL_VIEWED: 'agenda_visit_detail_page_viewed',
  DETAIL_ACTION_CLICKED: 'agenda_visit_detail_action_clicked',
  SEND_MESSAGE_CLICKED: 'agenda_visit_detail_send_message_clicked',
  NEW_VISIT_CLICKED: 'agenda_visit_detail_new_visit_clicked',
  THIRD_PARTY_INFO_CLICKED: 'visit_details_third_party_info_clicked',
  BRIEFING_WIDGET_VIEWED: 'visit_details_prepare_briefing_widget_view',
  BRIEFING_BUTTON_CLICKED: 'visit_details_prepare_briefing_button_clicked',
  SUGGESTION_VIEWED: 'agenda_visit_detail_suggestion_viewed',
  SUGGESTION_CLICKED: 'agenda_visit_detail_suggestion_clicked',
  LISTING_CLICKED: 'agenda_visit_detail_listing_clicked',
  CLIENT_PROFILE_CLICKED: 'client_profile_button_clicked',
  MORE_VISITS_VIEWED: 'shortcut_more_visits_viewed',
  MORE_VISITS_INTENT_CLICKED: 'shortcut_more_visits_intent_clicked',
  MORE_VISITS_REVIEW_VIEWED: 'shortcut_more_visits_review_page_viewed',
  MORE_VISITS_SCHEDULING_CLICKED:
    'shortcut_more_visits_visit_scheduling_clicked',
  MORE_VISITS_SUCCESS_VIEWED: 'shortcut_more_visits_success_page_viewed',
  MORE_VISITS_ERROR_VIEWED: 'shortcut_more_visits_error_page_viewed',
  CONFIRMATION_BUTTON_CLICKED: 'initiate_visit_confirmation_button_clicked',
  VISIT_CONFIRMED: 'visit_confirmed',
  CANCEL_CONTINUE_CLICKED: 'agenda_visit_cancellation_continue_clicked',
  RESCHEDULE_CLICKED: 'agenda_visit_dialog_reschedule_clicked',
  VISIT_RESCHEDULED: 'visit_rescheduled',
  OWNER_CONTACT_CLICKED: 'owner_contact_open_clicked',
  OFFER_LINK_SUCCESS: 'offer_link_success',
  OFFER_LINK_FAILURE: 'offer_link_failure',
  FINALIZATION_DIALOG_ACTION: 'visit_finalization_agent_dialog_button_clicked',
  TALK_TO_TENANT_CLICKED: 'agenda_visit_detail_talk_to_tenant',
  TENANT_BEST_PRACTICES_CLICKED: 'visit_details_best_practices_living_tenant',
  CALL_LIVING_TENANT: 'call_living_tenant',
  WHATSAPP_LIVING_TENANT: 'whatsapp_living_tenant',
  TENANT_CONTINUE_RESCHEDULE: 'tenant_living_continue_reschedule',
});

export const VISIT_FINALIZATION_USER_ACTIONS = Object.freeze({
  DONE: 'visit_done_intent',
  UNSUCCESSFUL: 'visit_unsucessful_intent',
});

export const visitFinalizationUserAction = outcome =>
  outcome === 'done'
    ? VISIT_FINALIZATION_USER_ACTIONS.DONE
    : VISIT_FINALIZATION_USER_ACTIONS.UNSUCCESSFUL;

export const OFFER_TRACKING_EVENTS = Object.freeze({
  PAGE_VIEWED: 'offer_pageview',
  DETAILS_VIEWED: 'offer_details_pageview',
  TAB_CLICKED: 'offer_tab_clicked',
  REFRESH_CLICKED: 'offer_refresh_button_clicked',
  QUICK_FILTER_CLICKED: 'offer_quick_filters_clicked',
  TYPE_FILTER_CLEARED: 'offer_filters_type_clear_clicked',
  CHAT_CLICKED: 'offer_details_chat_button_clicked',
  ACTIVITY_FILTER_APPLIED: 'offer_filters_recent_activities_apply_clicked',
  ACTIVITY_FILTER_CLEARED: 'offer_filters_recent_activities_clear_clicked',
  ERROR_REFRESH_CLICKED: 'offer_error_refresh_button_clicked',
  STATUS_LIST_ERROR_REFRESH_CLICKED:
    'offer_status_list_error_refresh_button_clicked',
});

export const createVisitTrackingPayload = ({ visit, action, extra = {} }) =>
  visitTrackingPayload(visit, {
    action,
    page_name: 'VISIT_DETAIL',
    ...extra,
  });

export const trackVisitEvent = ({ track, event, visit, action, extra = {} }) =>
  trackQuintoEvent(
    track,
    event,
    createVisitTrackingPayload({ visit, action, extra })
  );

export const createOfferTrackingPayload = ({
  offer,
  statusBucket,
  action,
  extra = {},
}) => ({
  pageName: 'OFFERS_PAGE',
  offer_id: offer?.id,
  sales_flow_id: offer?.salesFlowId || offer?.sales_flow_id || offer?.id,
  status: offer?.status,
  status_bucket: statusBucket,
  house_id: offer?.imovelId || offer?.imovel_id,
  contact_id: offer?.contactId || offer?.contact_id,
  action,
  ...extra,
});

export const trackOfferEvent = ({
  track,
  event,
  offer,
  statusBucket,
  action,
  extra = {},
}) =>
  trackQuintoEvent(
    track,
    event,
    createOfferTrackingPayload({ offer, statusBucket, action, extra })
  );
